
      import React from "react";
      import AddToWishlist from '@empiriecom/module-components/Icon/default/AddToWishlist32';
import Adoptarrow from '@empiriecom/module-components/Icon/jelmolich/Adoptarrow32';
import Adressbook from '@empiriecom/module-components/Icon/default/Adressbook32';
import Advantage from '@empiriecom/module-components/Icon/default/Advantage32';
import Android from '@empiriecom/module-components/Icon/default/Android32';
import App from '@empiriecom/module-components/Icon/default/App32';
import ArrowLargeDown from '@empiriecom/module-components/Icon/jelmolich/ArrowLargeDown32';
import ArrowLargeLeft from '@empiriecom/module-components/Icon/jelmolich/ArrowLargeLeft32';
import ArrowLargeRight from '@empiriecom/module-components/Icon/jelmolich/ArrowLargeRight32';
import ArrowLargeUp from '@empiriecom/module-components/Icon/jelmolich/ArrowLargeUp32';
import ArrowMediumDown from '@empiriecom/module-components/Icon/default/ArrowMediumDown32';
import ArrowMediumLeft from '@empiriecom/module-components/Icon/default/ArrowMediumLeft32';
import ArrowMediumRight from '@empiriecom/module-components/Icon/default/ArrowMediumRight32';
import ArrowMediumUp from '@empiriecom/module-components/Icon/default/ArrowMediumUp32';
import ArrowMiniDown from '@empiriecom/module-components/Icon/jelmolich/ArrowMiniDown32';
import ArrowMiniLeft from '@empiriecom/module-components/Icon/jelmolich/ArrowMiniLeft32';
import ArrowMiniRight from '@empiriecom/module-components/Icon/jelmolich/ArrowMiniRight32';
import ArrowMiniUp from '@empiriecom/module-components/Icon/jelmolich/ArrowMiniUp32';
import Basket from '@empiriecom/module-components/Icon/jelmolich/Basket32';
import Billing from '@empiriecom/module-components/Icon/default/Billing32';
import Blog from '@empiriecom/module-components/Icon/default/Blog32';
import Burger from '@empiriecom/module-components/Icon/jelmolich/Burger32';
import BurgerText from '@empiriecom/module-components/Icon/jelmolich/BurgerText32';
import Calendar from '@empiriecom/module-components/Icon/jelmolich/Calendar32';
import Cancel from '@empiriecom/module-components/Icon/default/Cancel32';
import Canceled from '@empiriecom/module-components/Icon/default/Canceled32';
import CancelFat from '@empiriecom/module-components/Icon/jelmolich/CancelFat32';
import CatHome from '@empiriecom/module-components/Icon/default/CatHome32';
import Category from '@empiriecom/module-components/Icon/default/Category32';
import Chat from '@empiriecom/module-components/Icon/default/Chat32';
import CheckOrder from '@empiriecom/module-components/Icon/default/CheckOrder32';
import Checkmark from '@empiriecom/module-components/Icon/jelmolich/Checkmark32';
import ClearInput from '@empiriecom/module-components/Icon/default/ClearInput32';
import Clock from '@empiriecom/module-components/Icon/default/Clock32';
import Collapse16 from '@empiriecom/module-components/Icon/default/Collapse1632';
import Copy from '@empiriecom/module-components/Icon/default/Copy32';
import Creditcard from '@empiriecom/module-components/Icon/default/Creditcard32';
import Delivery from '@empiriecom/module-components/Icon/jelmolich/Delivery32';
import DelayedPayment from '@empiriecom/module-components/Icon/default/DelayedPayment';
import Disadvantage from '@empiriecom/module-components/Icon/default/Disadvantage32';
import Dislike from '@empiriecom/module-components/Icon/default/Dislike32';
import Disposal from '@empiriecom/module-components/Icon/default/Disposal32';
import Download from '@empiriecom/module-components/Icon/default/Download32';
import Downsize from '@empiriecom/module-components/Icon/default/Downsize32';
import Edit from '@empiriecom/module-components/Icon/jelmolich/Edit32';
import Enlarge from '@empiriecom/module-components/Icon/jelmolich/Enlarge32';
import Error from '@empiriecom/module-components/Icon/jelmolich/Error32';
import Expand16 from '@empiriecom/module-components/Icon/default/Expand1632';
import Fabricsamples from '@empiriecom/module-components/Icon/default/Fabricsamples32';
import Facebook from '@empiriecom/module-components/Icon/default/Facebook32';
import Filter from '@empiriecom/module-components/Icon/default/Filter32';
import Fullscreen from '@empiriecom/module-components/Icon/default/Fullscreen32';
import Gallery from '@empiriecom/module-components/Icon/default/Gallery32';
import GalleryMore from '@empiriecom/module-components/Icon/default/GalleryMore32';
import GooglePlus from '@empiriecom/module-components/Icon/default/GooglePlus32';
import InDelivery from '@empiriecom/module-components/Icon/default/InDelivery32';
import Information from '@empiriecom/module-components/Icon/default/Information12';
import Instagram from '@empiriecom/module-components/Icon/default/Instagram32';
import Installation from '@empiriecom/module-components/Icon/default/Installation32';
import Installmentplan from '@empiriecom/module-components/Icon/default/Installmentplan32';
import Invoice from '@empiriecom/module-components/Icon/default/Invoice32';
import Ios from '@empiriecom/module-components/Icon/default/Ios32';
import LanguageSwitch from '@empiriecom/module-components/Icon/default/LanguageSwitch32';
import Like from '@empiriecom/module-components/Icon/default/Like32';
import List from '@empiriecom/module-components/Icon/jelmolich/List32';
import LoadReload from '@empiriecom/module-components/Icon/default/LoadReload32';
import LocationPin from '@empiriecom/module-components/Icon/default/LocationPin32';
import LogIn from '@empiriecom/module-components/Icon/default/LogIn32';
import LogOut from '@empiriecom/module-components/Icon/default/LogOut32';
import LoginClosed from '@empiriecom/module-components/Icon/default/LoginClosed32';
import LoginOpened from '@empiriecom/module-components/Icon/default/LoginOpened32';
import Mail from '@empiriecom/module-components/Icon/default/Mail32';
import MenuAndroid from '@empiriecom/module-components/Icon/default/MenuAndroid32';
import MenuIos from '@empiriecom/module-components/Icon/default/MenuIos32';
import Microphone from '@empiriecom/module-components/Icon/default/Microphone32';
import MicrophoneFilled from '@empiriecom/module-components/Icon/default/MicrophoneFilled32';
import MicrophoneIOs from '@empiriecom/module-components/Icon/default/MicrophoneIOs32';
import MicrophoneIOsFilled from '@empiriecom/module-components/Icon/default/MicrophoneIOsFilled32';
import Minus from '@empiriecom/module-components/Icon/jelmolich/Minus32';
import Newsletter from '@empiriecom/module-components/Icon/jelmolich/Newsletter32';
import Ordered from '@empiriecom/module-components/Icon/default/Ordered32';
import Paperplane from '@empiriecom/module-components/Icon/default/Paperplane32';
import PaymentDates from '@empiriecom/module-components/Icon/default/PaymentDates32';
import PaymentIn from '@empiriecom/module-components/Icon/default/PaymentIn32';
import PaymentInOut from '@empiriecom/module-components/Icon/default/PaymentInOut32';
import Paymentpause from '@empiriecom/module-components/Icon/default/Paymentpause32';
import Pdf from '@empiriecom/module-components/Icon/default/Pdf32';
import Phone from '@empiriecom/module-components/Icon/jelmolich/Phone32';
import Photo16 from '@empiriecom/module-components/Icon/default/Photo16';
import Photo from '@empiriecom/module-components/Icon/default/Photo32';
import Pinterest from '@empiriecom/module-components/Icon/default/Pinterest32';
import Placeholder from '@empiriecom/module-components/Icon/default/Placeholder32';
import Play from '@empiriecom/module-components/Icon/default/Play32';
import Plus from '@empiriecom/module-components/Icon/jelmolich/Plus32';
import Premiumlounge from '@empiriecom/module-components/Icon/default/Premiumlounge32';
import Return from '@empiriecom/module-components/Icon/default/Return32';
import Returnslip from '@empiriecom/module-components/Icon/default/Returnslip32';
import Search from '@empiriecom/module-components/Icon/jelmolich/Search32';
import Service from '@empiriecom/module-components/Icon/jelmolich/Service32';
import ServiceConsulting from '@empiriecom/module-components/Icon/jelmolich/ServiceConsulting32';
import ServiceHelp from '@empiriecom/module-components/Icon/jelmolich/ServiceHelp32';
import Settings from '@empiriecom/module-components/Icon/jelmolich/Settings32';
import ShipmentDetails from '@empiriecom/module-components/Icon/default/ShipmentDetails32';
import ShipmentTracking from '@empiriecom/module-components/Icon/default/ShipmentTracking32';
import Shippingflat from '@empiriecom/module-components/Icon/default/Shippingflat32';
import Sort from '@empiriecom/module-components/Icon/default/Sort32';
import Star from '@empiriecom/module-components/Icon/jelmolich/Star32';
import StarOutline from '@empiriecom/module-components/Icon/jelmolich/StarOutline32';
import Success from '@empiriecom/module-components/Icon/default/Success12';
import Surename from '@empiriecom/module-components/Icon/default/Surename32';
import TemplateRating from '@empiriecom/module-components/Icon/default/TemplateRating32';
import Textinput from '@empiriecom/module-components/Icon/default/Textinput32';
import Tracking from '@empiriecom/module-components/Icon/default/Tracking32';
import Trash from '@empiriecom/module-components/Icon/jelmolich/Trash32';
import TrashOpen from '@empiriecom/module-components/Icon/jelmolich/TrashOpen32';
import Truck from '@empiriecom/module-components/Icon/default/Truck32';
import Twitter from '@empiriecom/module-components/Icon/default/Twitter32';
import User from '@empiriecom/module-components/Icon/jelmolich/User32';
import Visibilty from '@empiriecom/module-components/Icon/default/Visibilty32';
import VisibiltyHidden from '@empiriecom/module-components/Icon/jelmolich/VisibiltyHidden32';
import Waiting from '@empiriecom/module-components/Icon/default/Waiting32';
import Warning from '@empiriecom/module-components/Icon/default/Warning12';
import Wishlist from '@empiriecom/module-components/Icon/default/Wishlist32';
import WishlistFilled from '@empiriecom/module-components/Icon/default/WishlistCss32';
import ZoomIn from '@empiriecom/module-components/Icon/jelmolich/ZoomIn32';
import ZoomOut from '@empiriecom/module-components/Icon/jelmolich/ZoomOut32';
import Alert from '@empiriecom/module-components/Icon/jelmolich/Alert32';
import ArrowUpRight from '@empiriecom/module-components/Icon/jelmolich/ArrowUpRight32';
import Award from '@empiriecom/module-components/Icon/jelmolich/Award32';
import Book from '@empiriecom/module-components/Icon/jelmolich/Book32';
import Compare from '@empiriecom/module-components/Icon/jelmolich/Compare32';
import Document from '@empiriecom/module-components/Icon/jelmolich/Document32';
import EmojiBad from '@empiriecom/module-components/Icon/jelmolich/EmojiBad32';
import EmojiGood from '@empiriecom/module-components/Icon/jelmolich/EmojiGood32';
import EmojiMedium from '@empiriecom/module-components/Icon/jelmolich/EmojiMedium32';
import Masonry from '@empiriecom/module-components/Icon/jelmolich/Masonry32';
import MoneyStar from '@empiriecom/module-components/Icon/jelmolich/MoneyStar32';
import OttoLogo from '@empiriecom/module-components/Icon/jelmolich/OttoLogo32';
import Present from '@empiriecom/module-components/Icon/jelmolich/Present32';
import QuestionBubble from '@empiriecom/module-components/Icon/jelmolich/QuestionBubble32';
import QuestionMark from '@empiriecom/module-components/Icon/jelmolich/QuestionMark32';
import Speechbubble from '@empiriecom/module-components/Icon/jelmolich/Speechbubble32';
import SquareList from '@empiriecom/module-components/Icon/jelmolich/SquareList32';
import UserFemale from '@empiriecom/module-components/Icon/jelmolich/UserFemale32';
import UserMale from '@empiriecom/module-components/Icon/jelmolich/UserMale32';
import Visbility from '@empiriecom/module-components/Icon/jelmolich/Visbility32';
import Warenhaus from '@empiriecom/module-components/Icon/jelmolich/Warenhaus32';
import Bademode from '@empiriecom/module-components/Icon/jelmolich/CatBademode32';
import Baumarkt from '@empiriecom/module-components/Icon/jelmolich/CatBaumarkt32';
import Festival from '@empiriecom/module-components/Icon/jelmolich/CatFestival32';
import Home from '@empiriecom/module-components/Icon/jelmolich/CatHome32';
import Kinder from '@empiriecom/module-components/Icon/jelmolich/CatKinder32';
import Marken from '@empiriecom/module-components/Icon/jelmolich/CatMarken32';
import MyStyle from '@empiriecom/module-components/Icon/jelmolich/CatMyStyle32';
import Schmuck from '@empiriecom/module-components/Icon/jelmolich/CatSchmuck32';
import Specials from '@empiriecom/module-components/Icon/jelmolich/CatSpecials32';
import Sport from '@empiriecom/module-components/Icon/jelmolich/CatSport32';
import Waesche from '@empiriecom/module-components/Icon/jelmolich/CatWaesche32';

      export default {
      AddToWishlist: AddToWishlist,
Adoptarrow: Adoptarrow,
Adressbook: Adressbook,
Advantage: Advantage,
Android: Android,
App: App,
ArrowLargeDown: ArrowLargeDown,
ArrowLargeLeft: ArrowLargeLeft,
ArrowLargeRight: ArrowLargeRight,
ArrowLargeUp: ArrowLargeUp,
ArrowMediumDown: ArrowMediumDown,
ArrowMediumLeft: ArrowMediumLeft,
ArrowMediumRight: ArrowMediumRight,
ArrowMediumUp: ArrowMediumUp,
ArrowMiniDown: ArrowMiniDown,
ArrowMiniLeft: ArrowMiniLeft,
ArrowMiniRight: ArrowMiniRight,
ArrowMiniUp: ArrowMiniUp,
Basket: Basket,
Billing: Billing,
Blog: Blog,
Burger: Burger,
BurgerText: BurgerText,
Calendar: Calendar,
Cancel: Cancel,
Canceled: Canceled,
CancelFat: CancelFat,
CatHome: CatHome,
Category: Category,
Chat: Chat,
CheckOrder: CheckOrder,
Checkmark: Checkmark,
ClearInput: ClearInput,
Clock: Clock,
Collapse16: Collapse16,
Copy: Copy,
Creditcard: Creditcard,
Delivery: Delivery,
DelayedPayment: DelayedPayment,
Disadvantage: Disadvantage,
Dislike: Dislike,
Disposal: Disposal,
Download: Download,
Downsize: Downsize,
Edit: Edit,
Enlarge: Enlarge,
Error: Error,
Expand16: Expand16,
Fabricsamples: Fabricsamples,
Facebook: Facebook,
Filter: Filter,
Fullscreen: Fullscreen,
Gallery: Gallery,
GalleryMore: GalleryMore,
GooglePlus: GooglePlus,
InDelivery: InDelivery,
Information: Information,
Instagram: Instagram,
Installation: Installation,
Installmentplan: Installmentplan,
Invoice: Invoice,
Ios: Ios,
LanguageSwitch: LanguageSwitch,
Like: Like,
List: List,
LoadReload: LoadReload,
LocationPin: LocationPin,
LogIn: LogIn,
LogOut: LogOut,
LoginClosed: LoginClosed,
LoginOpened: LoginOpened,
Mail: Mail,
MenuAndroid: MenuAndroid,
MenuIos: MenuIos,
Microphone: Microphone,
MicrophoneFilled: MicrophoneFilled,
MicrophoneIOs: MicrophoneIOs,
MicrophoneIOsFilled: MicrophoneIOsFilled,
Minus: Minus,
Newsletter: Newsletter,
Ordered: Ordered,
Paperplane: Paperplane,
PaymentDates: PaymentDates,
PaymentIn: PaymentIn,
PaymentInOut: PaymentInOut,
Paymentpause: Paymentpause,
Pdf: Pdf,
Phone: Phone,
Photo16: Photo16,
Photo: Photo,
Pinterest: Pinterest,
Placeholder: Placeholder,
Play: Play,
Plus: Plus,
Premiumlounge: Premiumlounge,
Return: Return,
Returnslip: Returnslip,
Search: Search,
Service: Service,
ServiceConsulting: ServiceConsulting,
ServiceHelp: ServiceHelp,
Settings: Settings,
ShipmentDetails: ShipmentDetails,
ShipmentTracking: ShipmentTracking,
Shippingflat: Shippingflat,
Sort: Sort,
Star: Star,
StarOutline: StarOutline,
Success: Success,
Surename: Surename,
TemplateRating: TemplateRating,
Textinput: Textinput,
Tracking: Tracking,
Trash: Trash,
TrashOpen: TrashOpen,
Truck: Truck,
Twitter: Twitter,
User: User,
Visibilty: Visibilty,
VisibiltyHidden: VisibiltyHidden,
Waiting: Waiting,
Warning: Warning,
Wishlist: Wishlist,
WishlistFilled: WishlistFilled,
ZoomIn: ZoomIn,
ZoomOut: ZoomOut,
Alert: Alert,
ArrowUpRight: ArrowUpRight,
Award: Award,
Book: Book,
Compare: Compare,
Document: Document,
EmojiBad: EmojiBad,
EmojiGood: EmojiGood,
EmojiMedium: EmojiMedium,
Masonry: Masonry,
MoneyStar: MoneyStar,
OttoLogo: OttoLogo,
Present: Present,
QuestionBubble: QuestionBubble,
QuestionMark: QuestionMark,
Speechbubble: Speechbubble,
SquareList: SquareList,
UserFemale: UserFemale,
UserMale: UserMale,
Visbility: Visbility,
Warenhaus: Warenhaus,
Bademode: Bademode,
Baumarkt: Baumarkt,
Festival: Festival,
Home: Home,
Kinder: Kinder,
Marken: Marken,
MyStyle: MyStyle,
Schmuck: Schmuck,
Specials: Specials,
Sport: Sport,
Waesche: Waesche,
      };